module.exports = __webpack_public_path__ + "img/xc.f767a3ae.png";